<template>
  <div class="events-list-wrap create-profile-wrapper">
    <div class="top-head">
      <div class="container">
        <div class="list-wrap">
          <div v-if="!isOwner" class="back-to-profile-text">
            <div class="d-flex place-items-center" @click="handleBackClick">
              <a-icon type="arrow-left" />
              <span class="margin-l-1">Back to profile</span>
            </div>
          </div>
          <div class="back">
            <span class="pointer-hover" @click="toggleFormShow" v-if="isForm">
              <a-icon type="arrow-left" />Back to Events List
            </span>
          </div>
          <div class="event-types">
            <div class="type" @click="changeEvents('new')">Promoted Events</div>
            <!-- <div
              v-if="
                !$route.params.id &&
                (onlyPremiumClubHeadCoach() || onlyClubHeadCoach())
              "
              class="type"
              @click="changeEvents('past')"
            >
              Previous Promoted Events
            </div> -->
            <div class="type" @click="changeEvents('hidden')">Team Events</div>
            <!-- <div
              v-if="
                !$route.params.id &&
                (onlyPremiumClubHeadCoach() || onlyClubHeadCoach())
              "
              class="type"
              @click="changeEvents('hidden-past')"
            >
              Previous Team Events
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="events-content-wrap">
        <div class="head">
          <div class="head-title" v-show="!isForm">
            <div class="name">{{ club.clubName }}</div>
            <h2 class="form-title">{{ pageTitle }}</h2>
          </div>
          <div class="add-event">
            <a-button
              type="primary"
              class="add-event-btn"
              icon="plus"
              @click="saveForm"
              v-if="
                !$route.params.id &&
                !isForm &&
                (onlyPremiumClubHeadCoach() || onlyClubHeadCoach())
              "
              >Add New Event</a-button
            >
          </div>
        </div>
        <div class="events-wrap" v-if="!isForm">
          <a-list
            :grid="{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 4 }"
            :dataSource="clubListEvents"
            :pagination="pagination"
            :loading="clubEventsLoading"
          >
            <a-list-item
              slot="renderItem"
              slot-scope="item"
              class="event-detail"
            >
              <EventCard
                :event="item"
                @onChange="editForm"
                :viewOnly="viewOnly"
                @delete="handleAfterDelete"
              />
            </a-list-item>
          </a-list>
        </div>
        <div class="form-wrap" v-else>
          <div class="form-content">
            <div class="heading">
              <h2
                class="form-title event-form-title"
                v-if="formType === 'save'"
              >
                Add New Event
              </h2>
              <h2 class="form-title" v-else>Edit Event</h2>
            </div>
            <a-form layout="horizontal" :form="form" @submit="handleSubmit">
              <div class="image-info">
                <BaseDragUpload
                  class="drag-image-wrapper"
                  @file-upload="(image) => handleImageUpload(image)"
                  :imageUrl="imageUrl"
                />
              </div>
              <div class="event-basic-info">
                <a-form-item label="Title">
                  <a-input
                    ref="title"
                    v-decorator="[
                      'title',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please enter title of the Event!',
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
                <a-form-item label="Description">
                  <a-textarea
                    ref="description"
                    :auto-size="{ minRows: 8, maxRows: 8 }"
                    v-decorator="[
                      'description',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please enter title of the Event!',
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="event-type-info">
                <a-row :gutter="24">
                  <a-col :sm="24">
                    <a-form-item label="Event Type">
                      <a-select
                        ref="eventType"
                        show-search
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        @change="handleEventChange"
                        v-decorator="[
                          'eventType',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select Event Type!',
                              },
                            ],
                          },
                        ]"
                        placeholder="Select Event Type"
                      >
                        <a-select-option
                          v-for="event in eventInfo.eventTypeList"
                          :key="event._id"
                          :value="event._id"
                          >{{ event.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :sm="12" v-if="currentEventType === 'Game Schedule'">
                    <a-form-item label="Team A">
                      <a-input
                        ref="teamA"
                        v-decorator="[
                          'teamA',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please select Team A!',
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="12" v-if="currentEventType === 'Game Schedule'">
                    <a-form-item label="Team B">
                      <a-input
                        ref="teamB"
                        v-decorator="[
                          'teamB',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please select Team B!',
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>
              <div class="date-time-info">
                <a-row :gutter="24">
                  <a-col :sm="8">
                    <a-form-item label="Date">
                      <a-date-picker
                        ref="date"
                        :style="{ width: '100%' }"
                        :disabled-date="disabledDate"
                        v-decorator="[
                          'date',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select Date!',
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="8">
                    <a-form-item label="Time">
                      <a-time-picker
                        ref="time"
                        :style="{ width: '100%' }"
                        use12-hours
                        format="h:mm a"
                        v-decorator="[
                          'time',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select Time!',
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="8">
                    <a-form-item label="Age Group">
                      <a-select
                        ref="age"
                        show-search
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        v-decorator="[
                          'age',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select Age Group!',
                              },
                            ],
                          },
                        ]"
                        placeholder="Select Age Group"
                      >
                        <a-select-option
                          v-for="age in eventInfo.ageGroupList"
                          :key="age._id"
                          :value="age._id"
                          >{{ age.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>
              <div class="location-info">
                <a-row :gutter="24">
                  <a-col :sm="12">
                    <a-form-item label="City">
                      <a-input
                        ref="city"
                        v-decorator="[
                          'city',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please enter City!',
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="12">
                    <a-form-item label="State">
                      <a-select
                        ref="state"
                        show-search
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        v-decorator="[
                          'state',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select State!',
                              },
                            ],
                          },
                        ]"
                        placeholder="Select State"
                      >
                        <a-select-option
                          v-for="state in eventInfo.stateList"
                          :key="state._id"
                          :value="state._id"
                          >{{ state.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :sm="24">
                    <a-form-item label="Address">
                      <a-input
                        ref="location"
                        v-decorator="[
                          'location',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please enter Location!',
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="24">
                    <a-form-item label="Google Location">
                      <a-input v-decorator="['googleLocation']" />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="24">
                    <a-form-item label="Sponsor">
                      <a-input
                        ref="sponsor"
                        v-decorator="[
                          'sponsor',
                          {
                            rules: [
                              {
                                required: false,
                                message: 'Please mention sponsor!',
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="24">
                    <a-form-item>
                      <a-checkbox
                        :checked="checkHidden"
                        @change="handleChangeHidden"
                        >Hide on Promoted Events Tab?</a-checkbox
                      >
                    </a-form-item>
                    <p class="note-on-checkbox">
                      <b>Note:</b>
                      If you are not the Host of the event please check this box
                      so it does not appear of the Promoted Events Page. This
                      event will appear in the Team Events section of your
                      profile.
                    </p>
                  </a-col>
                </a-row>
              </div>

              <a-form-item>
                <div class="button-wrapper d-flex-spc-btwn">
                  <span>
                    <a-button
                      type="primary"
                      html-type="submit"
                      class="next-button save-button"
                      >Save</a-button
                    >
                  </span>
                  <span>
                    <a-button
                      type="primary"
                      class="next-button"
                      @click="cancelForm"
                      >Cancel</a-button
                    >
                  </span>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import EventCard from "./card";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import isEmpty from "@/utils/isEmpty";

const STORE_KEY = "clubStore";
const CLUB_EVENT_STORE_KEY = "clubEventStore";
const taxonomyRepository = RepositoryFactory.get("taxonomy");

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

export default {
  name: "ClubEventList",
  components: {
    EventCard,
  },
  data() {
    return {
      isForm: false,
      imageSrc: "",
      imageUrl: "",
      formType: "save",
      toEditId: "",
      currentEventType: "",
      viewOnly: false,
      pageTitle: "Promoted Events",
      taxonomyvalues: [
        {
          name: "stateList",
          taxValue: "State",
        },
        {
          name: "ageGroupList",
          taxValue: "Age Group",
        },
        {
          name: "eventTypeList",
          taxValue: "Club Event Type",
        },
      ],
      eventInfo: {
        stateList: [],
        eventTypeList: [],
        ageGroupList: [],
      },
      currentPage: 1,
      checkHidden: false,
      hasErrors,
      form: this.$form.createForm(this),
      pagination: {
        onChange: (page) => ({}),
        pageSize: 12,
        simple: true,
      },
      eventTime: "new",
      eventToGet: "new",
    };
  },
  mounted() {
    this.$store.dispatch(`${STORE_KEY}/getClub`, {
      id: this.clubId,
    });
    this.getUpcoming();
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields();
    });
  },
  created() {
    for (let i = 0; i < this.taxonomyvalues.length; i++) {
      taxonomyRepository
        .getSortedTaxonomyValues(this.taxonomyvalues[i].taxValue)
        .then((response) => {
          this.eventInfo[this.taxonomyvalues[i].name] =
            response.data.taxonomy.values;
        });
    }
  },
  computed: {
    ...mapGetters({
      club: `${STORE_KEY}/club`,
      clubListEvents: `${CLUB_EVENT_STORE_KEY}/clubListEvents`,
      clubEventsLoading: `${CLUB_EVENT_STORE_KEY}/clubEventsLoading`,
      clubEventsMeta: `${CLUB_EVENT_STORE_KEY}/clubEventsMeta`,
    }),
    clubId() {
      return this.$route.params.id || localStorage["club-id"];
    },
    isOwner() {
      return this.clubId === localStorage["club-id"];
    },
    currentDate() {
      const currentDate = new Date();
      const month = `0${currentDate.getMonth() + 1}`;
      return `${currentDate.getFullYear()}/${
        month.length === 2
          ? month
          : `${month.split("")[1]}${month.split("")[2]}`
      }/${currentDate.getDate()}`;
    },
  },
  methods: {
    handleBackClick() {
      this.$router.push(
        `/${this.$route.params.profileId}/club_profile/${this.$route.params.id}/summary`
      );
    },
    getUpcoming(page = 1) {
      this.currentPage = page;
      this.$store.dispatch(`${CLUB_EVENT_STORE_KEY}/getClubEventsList`, {
        page,
        sort: "date",
        displayOnProfile: true,
        "date[gte]": this.currentDate,
        clubId: this.clubId,
      });
      this.viewOnly = false;
      this.pageTitle = "Promoted Events";
      this.imageUrl = "";
    },
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },
    getPast(page = 1) {
      this.currentPage = page;
      this.$store.dispatch(`${CLUB_EVENT_STORE_KEY}/getClubEventsList`, {
        page,
        sort: "-date",
        displayOnProfile: true,
        "date[lte]": this.currentDate,
        clubId: this.clubId,
      });
      this.viewOnly = true;
      this.pageTitle = "Previous Promoted Events";
      this.imageUrl = "";
    },
    async getHidden(page = 1) {
      this.currentPage = page;
      await this.$store.dispatch(`${CLUB_EVENT_STORE_KEY}/getClubEventsList`, {
        page,
        sort: "date",
        displayOnProfile: false,
        clubId: this.clubId,
        "date[gte]": this.currentDate,
      });
      this.viewOnly = false;
      this.pageTitle = "Team Events";
      this.imageUrl = "";
    },

    async getHiddenPast(page = 1) {
      this.currentPage = page;
      await this.$store.dispatch(`${CLUB_EVENT_STORE_KEY}/getClubEventsList`, {
        page,
        sort: "-date",
        displayOnProfile: false,
        clubId: this.clubId,
        "date[lte]": this.currentDate,
      });
      this.viewOnly = true;
      this.pageTitle = "Previous Team Events";
      this.imageUrl = "";
    },
    toggleFormShow() {
      this.isForm = !this.isForm;
    },
    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields((err, values) => {
        if (err) {
          this.$refs[Object.keys(err)[0]].focus();
        }
        if (!err) {
          let toSend = {
            title: values.title,
            description: values.description,
            date: new Date(values.date).toLocaleDateString(),
            time: values.time.format("hh:mm A"),
            state: values.state,
            city: values.city,
            location: values.location,
            age: values.age,
            googleLocation: values.googleLocation ? values.googleLocation : "",
            sponsor: values.sponsor,
            eventType: values.eventType,
            teamA: values.teamA ? values.teamA : "",
            teamB: values.teamB ? values.teamB : "",
            slug: "clubevent",
          };
          toSend.displayOnProfile = !this.checkHidden;
          if (this.formType === "save") {
            toSend.clubId = localStorage.getItem("club-id");
            toSend.clubName = this.club.clubName;
            this.saveEvent(toSend);
          } else {
            this.editEvent(toSend);
          }
        }
      });
    },

    async saveEvent(toSend) {
      await this.$store.dispatch(
        `${CLUB_EVENT_STORE_KEY}/createClubEventsList`,
        {
          toSend,
        }
      );
      let formData = new FormData();
      formData.append("file", this.imageSrc);
      if (this.imageSrc)
        await this.$store.dispatch(
          `${CLUB_EVENT_STORE_KEY}/updateImageForEvent`,
          {
            id: this.clubListEvents[0].id,
            image: formData,
          }
        );
      this.getUpcoming();
      this.isForm = !this.isForm;
    },

    async editEvent(toSend) {
      await this.$store.dispatch(
        `${CLUB_EVENT_STORE_KEY}/updateClubEventsList`,
        {
          toSend,
          id: this.toEditId,
        }
      );
      let formData = new FormData();
      formData.append("file", this.imageSrc);
      if (
        this.imageSrc !==
        this.clubListEvents.find((event) => event.id === this.toEditId)["image"]
      )
        await this.$store.dispatch(
          `${CLUB_EVENT_STORE_KEY}/updateImageForEvent`,
          {
            id: this.toEditId,
            image: formData,
          }
        );
      this.getUpcoming();
      this.isForm = !this.isForm;
    },

    handleChangeHidden(e) {
      this.checkHidden = e.target.checked;
    },

    changeEvents(val) {
      this.eventToGet = val;
      if (val === "new") {
        this.getUpcoming();
      } else if (val === "past") {
        this.getPast();
      } else if (val === "hidden") {
        this.getHidden();
      } else if (val === "hidden-past") {
        this.getHiddenPast();
      }
      this.isForm = false;
      this.formType = "save";
      this.currentEventType = "";
      this.toEditId = "";
    },

    handleEventChange(value) {
      let type = this.eventInfo.eventTypeList.filter(
        (type) => type._id === value
      );
      this.currentEventType = type[0].name;
    },

    saveForm() {
      this.isForm = !this.isForm;
      this.formType = "save";
      this.checkHidden = false;
    },
    cancelForm() {
      this.isForm = false;
      this.formType = "save";
      this.currentEventType = "";
      this.toEditId = "";
      this.imageUrl = "";
    },
    editForm(value) {
      this.isForm = true;
      this.imageUrl = value.image;
      this.formType = "edit";
      this.toEditId = value.id;
      this.imageSrc = value.image;
      this.checkHidden = this.pageTitle === "Team Events";
      let d = new Date(value.date);
      let that = this;
      if (value.eventType.name === "Game Schedule") {
        this.currentEventType = "Game Schedule";
      }
      setTimeout(function () {
        that.form.setFieldsValue({
          title: value.title,
          description: value.description,
          state: value.state
            ? value.state._id
              ? value.state._id
              : value.state
            : "",
          city: value.city,
          age: value.age ? (value.age._id ? value.age._id : value.age) : "",
          date: moment(d).format("YYYY-MM-DD"),
          time: moment(value.time, "hh:mm A"),
          location: value.location,
          googleLocation: value.googleLocation,
          sponsor: value.sponsor,
          eventType: value.eventType
            ? value.eventType._id
              ? value.eventType._id
              : value.eventType
            : "",
          teamA: value.teamA ? value.teamA : "",
          teamB: value.teamB ? value.teamB : "",
          slug: "clubEvent",
        });
      }, 1000);
    },

    handleImageUpload(image) {
      this.imageSrc = image;
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // Only show error after a field is touched.
    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    },
    handleAfterDelete() {
      if (this.eventToGet === "new") {
        this.getUpcoming();
      } else if (this.eventToGet === "past") {
        this.getPast();
      } else if (this.eventToGet === "hidden") {
        this.getHidden();
      } else if (this.eventToGet === "hidden-past") {
        this.getHiddenPast();
      }
    },
  },
};
</script>
<style lang="scss">
.note-on-checkbox {
  color: #e96d0a;
}
</style>
